import { Heading } from "theme-ui";
import { ColorModeToggle } from "@smerth/gatsby-theme-theme-ui";
import * as React from 'react';
export default {
  Heading,
  ColorModeToggle,
  React
};